import { render, staticRenderFns } from "./InboxWindowEmpty.vue?vue&type=template&id=2b142f70"
import script from "./InboxWindowEmpty.vue?vue&type=script&lang=ts"
export * from "./InboxWindowEmpty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b142f70')) {
      api.createRecord('2b142f70', component.options)
    } else {
      api.reload('2b142f70', component.options)
    }
    module.hot.accept("./InboxWindowEmpty.vue?vue&type=template&id=2b142f70", function () {
      api.rerender('2b142f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindowEmpty.vue"
export default component.exports